import React, { useState } from "react";
import "./ArtificialIntelligence.scss";
import QuoteModal from "../../../../Components/QuoteModal";
import AIConsultingServices from "../../../../Assets/Red_Theme/services/AIConsultingServices.png";
import CustomAISoftwareDevelopment from "../../../../Assets/Red_Theme/services/CustomAISoftwareDevelopment.png";
import ouiIntegrationGeneral from "../../../../Assets/Red_Theme/services/ouiIntegrationGeneral.svg";
import hugeiconsAiGenerative from "../../../../Assets/Red_Theme/services/hugeiconsAiGenerative.svg";
import AIAssistantChatbotDevelopment from "../../../../Assets/Red_Theme/services/AIAssistantChatbotDevelopment.svg";
import machineLearningModelSvgrepo from "../../../../Assets/Red_Theme/services/machineLearningModelSvgrepo.svg";
import innovative from "../../../../Assets/Red_Theme/services/innovative.png";
import innovativeAppBgImg from "../../../../Assets/Red_Theme/services/innovativeAppBgImg.png";
import AiDevelopment from "../../../../Assets/Red_Theme/services/AiDevelopment.svg";
import checkIcon from "../../../../Assets/Red_Theme/checkIcon.svg";
import automation from "../../../../Assets/Red_Theme/automation.svg";
import dataAnalysisandInsights from "../../../../Assets/Red_Theme/dataAnalysisandInsights.svg";
import Personalization from "../../../../Assets/Red_Theme/Personalization.svg";
import improvedHealthcare from "../../../../Assets/Red_Theme/improvedHealthcare.svg";
import advancementsInEducation from "../../../../Assets/Red_Theme/advancementsInEducation.svg";
import CountUp from "react-countup";
import LetDiscuss from "../../../../Components/LetDiscuss";
import futuristic from "../../../../Assets/Red_Theme/futuristic.svg";
// import chooseVidhan1 from "../../../../Assets/Red_Theme/chooseVidhan1.png";
// import chooseVidhan2 from "../../../../Assets/Red_Theme/chooseVidhan2.png";
// import chooseVidhan3 from "../../../../Assets/Red_Theme/chooseVidhan3.png";
// import chooseVidhan4 from "../../../../Assets/Red_Theme/chooseVidhan4.png";
function CountUpBox(props) {
  return (
    <div className={`statistic_container ${props.Class}`}>
      <div className={`about_statistic ${props.Class}`}>
        <span>
          <CountUp end={props.Count} duration={props.Duration} />
          <span className="symbol">{props.Symbol}</span>
        </span>
        <h4>{props.Title}</h4>
      </div>
    </div>
  );
}
function ArtificialIntelligence() {
  const [isOpen, setOpen] = useState(false);
  const [subject, setSubject] = useState(null);
  const OpenModal = (data) => {
    setSubject(data);
    setOpen(true);
  };

  const developmentBoxes = [
    {
      icon: AIConsultingServices,
      title: "AI Consulting Services",
      desc: "Our AI consulting services deliver cutting-edge solutions infused with the latest technologies, tools, and functions to enhance business and startup performance. From ideation to AI strategy and model design, we offer end-to-end AI consulting.",
    },
    {
      icon: CustomAISoftwareDevelopment,
      title: "Custom AI Software Development",
      desc: "As a top AI development company, we utilize advanced algorithms and machine learning to create scalable and reliable AI software. Our solutions help businesses and startups enhance growth, efficiency, and user experience.",
    },
    {
      icon: ouiIntegrationGeneral,
      title: "AI Software Integration and Optimization",
      desc: "Our cutting-edge AI software integration services boost system performance and streamline business operations by automating complex tasks. Our experts optimize AI solutions to drive efficiency across various industries.",
    },
    {
      icon: hugeiconsAiGenerative,
      title: "Generative AI",
      desc: "We specialize in Generative AI development, providing expert AI software developers to create intelligent and scalable solutions. Our AI-driven innovations empower startups and businesses to stay ahead in the evolving tech landscape.",
    },
    {
      icon: AIAssistantChatbotDevelopment,
      title: "AI Assistant and Chatbot Development",
      desc: "As a leading AI development company, we specialize in conversational AI solutions, including AI assistants and chatbot development. Our advanced chatbots enhance customer support, boost engagement, and drive customer satisfaction.",
    },
    {
      icon: machineLearningModelSvgrepo,
      title: "Machine Learning and AI Operating Systems",
      desc: "As a versatile AI development company, Vidhan Infotech specializes in Machine Learning solutions that enhance business efficiency. From data extraction to real-time analysis, our AI-powered services help businesses streamline operations and drive innovation.",
    },
  ];
  const whatAre = [
    {
      icon: automation,
      title: "Automation",
      desc: "AI automates repetitive tasks, allowing human resources to focus on strategic and creative initiatives. This enhances efficiency, reduces manual workload, and boosts productivity. Businesses can leverage AI to streamline operations and drive innovation.",
    },
    {
      icon: dataAnalysisandInsights,
      title: "Data Analysis and Insights",
      desc: "AI algorithms rapidly analyze vast datasets, identifying patterns and correlations beyond human detection. This allows businesses to gain valuable insights, optimize decision-making, and stay ahead of the competition.",
    },
    {
      icon: Personalization,
      title: "Personalization",
      desc: "AI-driven recommendation systems and virtual assistants personalize user experiences based on preferences. This improves customer engagement and satisfaction across industries like e-commerce, entertainment, and healthcare.",
    },
    {
      icon: improvedHealthcare,
      title: "Improved Healthcare",
      desc: "AI enhances healthcare by enabling faster and more accurate diagnoses through advanced medical imaging analysis. Predictive analytics helps doctors anticipate health risks, improving patient outcomes.",
    },
    {
      icon: advancementsInEducation,
      title: "Advancements in Education",
      desc: "AI enhances education by customizing learning paths, providing real-time tutoring, and making education more accessible. Personalized AI-driven teaching improves student performance and engagement.",
    },
  ];
  return (
    <>
      <section className="artificialIntelligence">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="artificialIntelligenceTitle">
                <h1>
                  AI <span>Development</span> Services
                </h1>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="artificialIntelligenceTitle">
                <p>
                  Automate your complex and tedious tasks with Bacancy’s AI
                  development services. Count on our Artificial Intelligence
                  professionals for end-to-end development, from ideation to
                  execution of AI solutions and AI integration to your existing
                  or support & maintenance. When you work with us, expect GPT
                  and LlaMa to deliver personalized, business-specific
                  solutions.
                </p>
                <button
                  className="theme_btn py-2"
                  onClick={() => OpenModal("AI Development Services")}
                >
                  <span>Let’s Discuss Your AI Requirement</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="weOffer">
        <div className="container">
          <div className="col-md-12 mb-5">
            <div className="artificialIntelligenceTitle">
              <h2>
                AI Development <span>Services</span> We Offer
              </h2>
              <p>
                Start leveraging our AI development services in this digital era
                to overcome challenges, boost productivity, reduce cost, and
                exceed business expectations.
              </p>
            </div>
          </div>
          <div className="row">
            {developmentBoxes.map((item, i) => (
              <div className="col-xl-4 col-md-6 col-sm-12" key={i}>
                <div className="developmentBoxes">
                  <div className="content">
                    <img className="icon" src={item?.icon} alt={item?.title} />
                    <h4>{item?.title}</h4>
                    <p>{item?.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="innovative">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-sm-12 m-auto">
              <img src={innovative} alt="" className="img-fluid w-100" />
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="artificialIntelligenceTitle">
                <h1>
                  Unlock Growth with Our <span>Innovative</span> AI Solutions
                </h1>
                <p>
                  Revolutionize Your Business with Vidhan Infotech’s AI
                  Solutions! Leverage the power of Artificial Intelligence to
                  enhance efficiency, automate operations, and drive
                  unparalleled growth. Our cutting-edge technology helps
                  businesses unlock new opportunities, streamline processes, and
                  stay ahead in the competitive market. Experience the next era
                  of innovation with Vidhan Infotech.
                </p>
                <button className="theme_btn py-2">
                  <span>Get In Touch</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="AiInnovativeApp">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <img src={AiDevelopment} className="img-fluid" alt="" />
            </div>
            <div className="col-md-6">
              <div className="box">
                <img src={innovativeAppBgImg} className="boxPettern" alt="" />
                <h2>
                  Our AI Development <span>Process</span>
                </h2>
                <ul>
                  <li>
                    <img src={checkIcon} alt="" />
                    Define the Project and Goals
                  </li>
                  <li>
                    <img src={checkIcon} alt="" />
                    Data Collection and Exploration
                  </li>
                  <li>
                    <img src={checkIcon} alt="" />
                    Model Design and Development
                  </li>
                  <li>
                    <img src={checkIcon} alt="" />
                    Model Evaluation and Testing
                  </li>
                  <li>
                    <img src={checkIcon} alt="" />
                    Deployment and Monitoring
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="whatAre">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-12">
              <div className="whatAreTitle">
                <h4 className="line_title">What Are</h4>
                <h2>
                  <span>Benefits</span> Of Artificial Intelligence
                </h2>
                <p>
                  Leverage AI to streamline operations, improve decision-making,
                  and boost growth.
                </p>
              </div>
            </div>
            {whatAre.map((item, i) => (
              <div className="col-lg-4 col-md-6 col-12" key={i}>
                <div className="developmentBoxes">
                  <div className="content">
                    <img className="icon" src={item?.icon} alt={item?.title} />
                    <h4>{item?.title}</h4>
                    <p>{item?.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="AiLetsWorkTogether">
        <div className="container">
          <div className="counterBoxes">
            <CountUpBox
              Class=""
              Count="43"
              Symbol="+"
              Duration="3"
              Title="Happy Clients"
            />
            <CountUpBox
              Class=""
              Count="70"
              Symbol="+"
              Duration="3"
              Title="Project Delivered"
            />
            <CountUpBox
              Class=""
              Count="23"
              Symbol="+"
              Duration="3"
              Title="Team Members"
            />
            <CountUpBox
              Class=""
              Count="7"
              Symbol="+"
              Duration="3"
              Title="Years Experience"
            />
          </div>
          <hr />
          <button className="theme_btn">
            <span>Let’s Work Together</span>
          </button>
        </div>
      </section>
      <section className="futuristicAiModal">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="softwareDevelopmentTitle">
                <h2>
                  Build A Highly Interactive and <span>Futuristic</span> AI
                  Model with US
                </h2>
                <p>
                  AI is transforming industries by driving automation and
                  boosting business efficiency. To build a powerful AI system,
                  you need an expert team with experience and innovation. With
                  over a decade of expertise, Vidhan Infotech delivers top-tier
                  AI development services, ensuring cutting-edge and scalable AI
                  solutions.
                </p>
                <p>
                  Connect with our AI development experts to integrate
                  cutting-edge technologies into your AI systems. Get highly
                  efficient, secure, and scalable AI software tailored to meet
                  your startup’s goals. With a proven track record, we deliver
                  world-class AI solutions to clients worldwide.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="rightImg">
                <img src={futuristic} className="img-fluid" alt="" />
                {/* <div className="imgbox">
                  <img src={chooseVidhan1} alt="" />
                  <img src={chooseVidhan2} alt="" />
                </div>
                <div className="imgbox">
                  <img src={chooseVidhan3} alt="" />
                  <img src={chooseVidhan4} alt="" />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <LetDiscuss />
      <section className="letsGetWork">
        <div className="container">
          <div className="col-md-12 mb-5">
            <div className="letsGetWorkTitle">
              <h2>
                Have a <span>project</span> in mind? <br /> Let’s get to work
              </h2>
              <button className="theme_btn py-2">
                <span>Request a Free Quote Today</span>
              </button>
            </div>
          </div>
        </div>
      </section>
      {isOpen && (
        <QuoteModal
          open={isOpen}
          setOpen={setOpen}
          CloseModal={() => setOpen(false)}
          subject={subject}
        />
      )}
    </>
  );
}

export default React.memo(ArtificialIntelligence);
